import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  { name: "Rohan Mehta", city: "Delhi → Manali", trip: "Outstation", rating: 5,
    text: "Booked an Innova for a 5-day Manali trip. Driver was super polite and the car was spotless. Pricing was honest and confirmed instantly on WhatsApp." },
  { name: "Priya Sharma", city: "Chandigarh → IGI Airport", trip: "One Way", rating: 5,
    text: "Got a sedan for a late-night airport drop. Driver was on time, ride was smooth and the car had AC blowing perfectly. Will book again." },
  { name: "Ankit Verma", city: "Jaipur → Udaipur", trip: "Outstation", rating: 5,
    text: "We took a Tempo Traveller for a family wedding trip. 12 of us travelled comfortably. The driver handled hill roads like a pro." },
  { name: "Sneha Iyer", city: "Mumbai Local", trip: "Airport Transfer", rating: 5,
    text: "I had an early morning flight and was nervous about pickup. Cabsab driver reached 15 mins early and helped with luggage. Stress-free travel!" },
  { name: "Vikram Singh", city: "Ludhiana → Amritsar", trip: "One Way", rating: 4,
    text: "Quick one-way booking on WhatsApp. Got a Dzire within 30 mins. Clean car, fair price, no haggling. This is how cab booking should be." },
  { name: "Meera Reddy", city: "Bengaluru → Coorg", trip: "Outstation", rating: 5,
    text: "Weekend trip to Coorg with friends — booked an SUV. Driver knew all the scenic spots and even suggested good food stops on the way. 10/10." },
];

const Testimonials = () => {
  return (
    <section id="reviews" data-testid="testimonials-section" className="relative py-20 lg:py-28 bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div className="max-w-xl">
            <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#19A8E8]">Real Reviews</div>
            <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#0F172A] tracking-tight leading-tight">
              Loved by <span className="text-[#19A8E8]">1 Lakh+</span> travellers
            </h2>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-[#19A8E8] text-[#19A8E8]" />
              ))}
            </div>
            <div>
              <div className="font-display font-bold text-2xl text-[#0F172A] leading-none">4.9 / 5</div>
              <div className="text-xs text-[#64748B] mt-1">Across Google &amp; WhatsApp</div>
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              data-testid={`testimonial-${r.name.replace(/\s+/g, "-").toLowerCase()}`}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              className="relative bg-white rounded-2xl p-6 lg:p-7 border border-slate-200 hover:shadow-[0_12px_30px_rgba(15,23,42,0.08)] hover:border-[#19A8E8]/40 hover:-translate-y-1 transition-all"
            >
              <Quote className="absolute top-5 right-5 h-8 w-8 text-[#19A8E8]/15" />
              <div className="flex items-center gap-1">
                {Array.from({ length: r.rating }).map((_, idx) => (
                  <Star key={idx} className="h-4 w-4 fill-[#19A8E8] text-[#19A8E8]" />
                ))}
              </div>
              <p className="mt-4 text-[#0F172A] leading-relaxed text-[15px]">"{r.text}"</p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-slate-100">
                <div className="h-10 w-10 rounded-full bg-[#19A8E8] text-white flex items-center justify-center font-display font-bold">
                  {r.name.charAt(0)}
                </div>
                <div className="flex-1">
                  <div className="font-display font-semibold text-[#0F172A]">{r.name}</div>
                  <div className="text-xs text-[#64748B]">{r.city}</div>
                </div>
                <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-[#19A8E8] bg-[#19A8E8]/10 px-2.5 py-1 rounded-full">
                  {r.trip}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
